<template>
  <!--    课程-->
  <div>
    <a :href="param.data.url">
      <div class="kc-more-box">
        <img class="kc-more" :src="param.data.image" alt="" />
      </div>
    </a>
  </div>

</template>

<script>
export default {
  name: "adItem",
  props:['param'],
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.kc-more-box{
  width: 696px;margin: 10px auto 0;
  .kc-more{
    width: 100%;display: block;height: auto;
  }
}
</style>
